/**
 * Mobile Author Bar front-end behaviour — copy the article's address, and say so.
 *
 * The one behaviour on this bar that the platform cannot give us declaratively. It used to
 * fail — and succeed — in silence; the founder tapped it on his phone on 2026-09-20 and
 * reported the button as broken. The reasoning, the fallback and the reserved label width all
 * live in `../article-shared/copy-link`, which the article drawer's button shares.
 */

import { initCopyLink } from '../article-shared/copy-link';

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll(
			'.wp-block-avoid-content-mobile-author-bar [data-ac-copy-link]'
		)
		.forEach( initCopyLink );
} );
